// src/services/authService.js

// Get configuration from environment variables
const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN || 'https://faceaiauth.redbeardpi.com';
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID || '3t4k81ed304tmv4uf9000daf14';
const REDIRECT_URI = 'https://faceai.redbeardpi.com/auth/callback';

// Debug function to print configuration
const debugConfig = () => {
  console.log('Auth configuration:');
  console.log('- COGNITO_DOMAIN:', COGNITO_DOMAIN);
  console.log('- CLIENT_ID:', CLIENT_ID);
  console.log('- REDIRECT_URI:', REDIRECT_URI);
  console.log('- window.location.origin:', window.location.origin);
  console.log('- Full redirect URL used:', `${COGNITO_DOMAIN}/login?client_id=${CLIENT_ID}&response_type=code&scope=email+openid+profile&redirect_uri=${encodeURIComponent(REDIRECT_URI)}`);
};

// Login function - redirects to Cognito login page
export const login = () => {
  console.log("Login initiated, redirecting to Cognito");
  
  // Print debug information
  debugConfig();
  
  // Always use the production URL
  const effectiveRedirectUri = 'https://faceai.redbeardpi.com/auth/callback';
    
  console.log("Using redirect URI:", effectiveRedirectUri);
  
  const loginUrl = `${COGNITO_DOMAIN}/login?client_id=${CLIENT_ID}&response_type=code&scope=email+openid+profile&redirect_uri=${encodeURIComponent(effectiveRedirectUri)}`;
  
  // Store the current time to detect login timeouts
  localStorage.setItem('auth_redirect_time', Date.now());
  localStorage.setItem('redirect_uri_used', effectiveRedirectUri);
  
  window.location.href = loginUrl;
};

// Logout function - clears tokens and redirects to home
export const logout = () => {
  console.log("Logging out user");
  
  // Clear all authentication data
  localStorage.removeItem('id_token');
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('token_expiry');
  localStorage.removeItem('auth_redirect_time');
  
  // Redirect to home page after logout
  window.location.href = window.location.origin;
};

// Handle the callback from Cognito with authorization code
export const handleAuthentication = async (code) => {
  console.log("Handling authentication callback");
  console.log("Auth code:", code.substring(0, 10) + '...');
  
  // Always use the production URL for token exchange
  const redirectUriUsed = 'https://faceai.redbeardpi.com/auth/callback';
  console.log("Using redirect URI for token exchange:", redirectUriUsed);
  
  try {
    // In production, exchange code for tokens
    const response = await fetch('/api/auth/token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        code,
        redirectUri: redirectUriUsed,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error("Token exchange failed:", errorData);
      throw new Error(errorData.error || 'Failed to exchange code for tokens');
    }

    const { idToken, accessToken, expiresIn } = await response.json();

    // Store tokens in localStorage
    console.log("Storing tokens in localStorage");
    localStorage.setItem('id_token', idToken);
    localStorage.setItem('access_token', accessToken);
    localStorage.setItem('token_expiry', Date.now() + (expiresIn * 1000));
    
    // Verify tokens were stored
    console.log("Verifying tokens in localStorage");
    console.log("id_token in localStorage:", !!localStorage.getItem('id_token'));
    console.log("access_token in localStorage:", !!localStorage.getItem('access_token'));
    console.log("token_expiry in localStorage:", !!localStorage.getItem('token_expiry'));
    
    console.log("Authentication successful");
    return true;
  } catch (error) {
    console.error("Authentication error:", error);
    logout(); // Clean up in case of error
    throw error;
  }
};

// Check if user is authenticated
export const isAuthenticated = () => {
  console.log("Checking authentication status");
  
  const token = localStorage.getItem('id_token');
  const expiry = localStorage.getItem('token_expiry');
  
  if (!token || !expiry) {
    console.log("No token or expiry found");
    return false;
  }
  
  // Check if token is expired
  if (Date.now() > parseInt(expiry, 10)) {
    console.log("Token expired");
    // Could add refresh token logic here
    logout();
    return false;
  }
  
  console.log("User is authenticated");
  return true;
};

// Get the current user from the JWT token
export const getCurrentUser = () => {
  const token = localStorage.getItem('id_token');
  if (!token) return null;
  
  try {
    // Parse the JWT token to get user info
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Error parsing user token:", error);
    return null;
  }
};